'use strict';
module.exports = function createDom(htmlString) {

	const container = document.createElement('div');
	container.innerHTML = htmlString;
	return Array.from(container.children);
};
